/* eslint-disable no-unused-vars */
export default VUE => {
  return {
    setTestApiMsg(state, msg) {
      state.testApiMsg = msg
    },
    setInitDataPending(state) {
      state.initDataPending = true
    },
    unsetInitDataPending(state) {
      state.initDataPending = false
    },
    unsetNotice(state) {
      state.notices = []
    },
    setInitData(state, data) {
      // console.log('*[setInitData]', this.$app.$h.dumpObj(data))
      Object.assign(state, data)
      state.initDataPending = false
    },
    setNotice(state, data) {
      state.notice = data
    },
    setNotices(state, data) {
      state.notices = data
    },
    addNotice(state, data) {
      state.notices.push(data)
    },
    clearNotice(state) {
      state.notice = ''
    },
    clearNotices(state) {
      state.notices = []
    },
    setFilters(state, data) {
      if (!Array.isArray(data)) data = []
      // console.log('*[setFilters]', VUE.h.dumpObj(data))
      state.filters = data
    },
    resetFilters(state) {
      state.category.filters = {}
    },
    setCategory(state, data) {
      // console.log('*[setCategory]', this.$app.$h.dumpObj(_data))
      state.category = Object.assign({}, state.category, data)
      // for debug
      // window._products = state.category.products
      // window._filters = state.category.filters
    },
    setCategoryAccesorries(state, data) {
      state.category.accesorries = data
    },
    setBreadcrumbs(state, data) {
      state.breadcrumbs = data
    },
    setHeadline(state, data) {
      state.headline = data
    },
    setMenuMobile(state, data) {
      state.menuMobile = data
    },
    setSearchMobile(state, data) {
      state.searchMobile = data
    },
    setFiltersMobile(state, data) {
      state.filtersMobile = data
    },
    setProduct(state, data) {
      // console.log('*[setProduct]', this.$app.$h.dumpObj(data))
      if (typeof data !== 'object') data = {}
      state.product = Object.assign(
        {},
        state.product,
        Array.isArray(data) ? (data.length ? data[0] : []) : data
      )
    },
    resetProduct(state) {
      state.product = {}
      // todo
      // Object.assign(initProductStruct)
    },
    setCategorySort(state, data) {
      state.category.sort = data
    },
    setCategoryPage(state, data) {
      state.category.page = data
    },
    setCategoryPerPage(state, data) {
      state.category.perPage = data
    },
    setCategoryTotalPages(state, data) {
      state.category.total = data
    },
    setCategoryViewMode(state, data) {
      state.category.viewMode = data
    },
    setCategoryCurrentPath(state, data) {
      state.category.currentPath = data
    },
    setSelectedFilter(state, { filter, option }) {
      state.selectedFilters[filter] = option
    },
    setSelectedFilters(state, filters) {
      state.selectedFilters = filters
    },
    unsetSelectedFilter(state, filter) {
      if (typeof state.selectedFilters[filter] !== 'undefined') {
        delete state.selectedFilters[filter]
      }
    },
    resetSelectedFilters(state) {
      state.selectedFilters = {}
    },
    setDeferredFilters(state) {
      // state.category.deferredFilters = [...state.category.filters]
      state.category.deferredFilters = true
    },
    resetDeferredFilters(state) {
      // state.category.deferredFilters = {}
      state.category.deferredFilters = false
    },
    setSearchQuery(state, data) {
      state.searchQuery = data
    },
    setSearchResults(state, data) {
      state.search = data
    },
    setGalleryModal(state, data) {
      state.galleryModal = data
    },
    setNotifyStockModal(state, data) {
      state.notifyStockModal = data
    },
    setQuickOrderModal(state, data) {
      state.quickOrderModal = data
    },
    setPreOrderModal(state, data) {
      state.preOrderModal = data
    },
    setDeliveryModal(state, data) {
      state.deliveryModal = data
    },
    setNetpeakModal(state, data) {
      state.netpeakModal = data
    },
    setSubscribedUser(state, data) {
      state.subscribedUser = data
    },
    setSubscriptionSent(state, data) {
      state.subscriptionSent = data
    },
    setAppealResult(state, data) {
      state.appealResult = data
    },
    setProductInfoModal(state, data) {
      state.productInfoModal = data
    },
    setProductModal(state, data) {
      state.productModal = Object.assign({}, data)
    },
    addCartItem(state, data) {
      let item = state.cart.items.find(itm => itm.id === data._id)
      let inc = 1
      const isProfitable =
        Array.isArray(data.profitableKit) &&
        data.profitableKit.length &&
        !data.single
      if (isProfitable) {
        inc += 2
      }
      if (item) {
        item.qty++
      } else {
        item = {
          id: data._id,
          did: data.id,
          qty: 1,
          price: productPrice(data),
          priceUsd: productPriceUsd(data),
          img: data.img,
          kitDisc: data.kitDisc,
          name: data[`name_${VUE.APP.$i18n.locale}`] || data.name || '',
          link: productLink(data, state),
          warranty: Array.isArray(data.warranty) ? data.warranty : [],
          categoryPath: data.parentCategory || '',
        }
        if (isProfitable) {
          item.profitableKit = data.profitableKit
        }
        if (Array.isArray(data.childCategory)) {
          item.categoryPath += '/' + data.childCategory[0].replace(',', '/')
        }
        state.cart.items.push(item)
      }
      state.cart.price += item.price
      state.cart.priceUsd += item.priceUsd
      if (isProfitable) {
        console.log(data.kitDisc, 'isProfitable')
        if (data.kitDisc) {
          state.cart.price += Math.ceil(
            data.profitableKit[0].price -
              data.profitableKit[0].price * (data.kitDisc / 100)
          )
          state.cart.price += Math.ceil(
            data.profitableKit[1].price -
              data.profitableKit[1].price * (data.kitDisc / 100)
          )
          state.cart.priceUsd += Math.ceil(
            data.profitableKit[0].priceUsd -
              data.profitableKit[0].priceUsd * (data.kitDisc / 100)
          )
          state.cart.priceUsd += Math.ceil(
            data.profitableKit[1].priceUsd -
              data.profitableKit[1].priceUsd * (data.kitDisc / 100)
          )
        } else {
          state.cart.price += Math.ceil(data.profitableKit[0].price * 0.8)
          state.cart.price += Math.ceil(data.profitableKit[1].price * 0.8)
          state.cart.priceUsd += Math.ceil(data.profitableKit[0].priceUsd * 0.8)
          state.cart.priceUsd += Math.ceil(data.profitableKit[1].priceUsd * 0.8)
        }
      }
      state.cart.qty += inc
    },
    addWarranty(state, data) {
      let item = state.cart.items.find(itm => itm.id === data._id)
      if (item && !item.warranty.length) {
        item.warranty = data.warranty
      }
    },
    removeCartItem(state, id) {
      let qty = 0
      let price = 0
      let priceUsd = 0
      state.cart.items = state.cart.items.filter(item => {
        if (item.id === id) return false
        qty += item.qty
        price += qty * productPrice(item)
        priceUsd += qty * productPriceUsd(item)
        if (Array.isArray(item.profitableKit) && item.profitableKit.length) {
          console.log(item.kitDisc, 'Array.isArray')
          if (item.kitDisc) {
            price += Math.ceil(
              item.profitableKit[0].price -
                item.profitableKit[0].price * (item.kitDisc / 100)
            )
            price += Math.ceil(
              item.profitableKit[1].price -
                item.profitableKit[1].price * (item.kitDisc / 100)
            )
            priceUsd += Math.ceil(
              item.profitableKit[0].priceUsd -
                item.profitableKit[0].priceUsd * (item.kitDisc / 100)
            )
            priceUsd += Math.ceil(
              item.profitableKit[1].priceUsd -
                item.profitableKit[1].priceUsd * (item.kitDisc / 100)
            )
          } else {
            price += Math.ceil(item.profitableKit[0].price * 0.8)
            price += Math.ceil(item.profitableKit[1].price * 0.8)
            priceUsd += Math.ceil(item.profitableKit[0].priceUsd * 0.8)
            priceUsd += Math.ceil(item.profitableKit[1].priceUsd * 0.8)
          }
          qty += item.qty * 2
        }
        return true
      })
      state.cart.qty = qty
      state.cart.price = price
      state.cart.priceUsd = priceUsd
    },
    setCartItemQty(state, { id, qty }) {
      let item = state.cart.items.find(itm => itm.id === id)
      if (item) {
        let q = +qty
        state.cart.qty -= item.qty
        state.cart.price -= item.qty * productPrice(item)
        state.cart.priceUsd -= item.qty * productPriceUsd(item)
        if (Array.isArray(item.profitableKit) && item.profitableKit.length) {
          console.log(item.kitDisc, 'Array.isArray2')
          if (item.kitDisc) {
            state.cart.price -=
              item.qty *
              Math.ceil(
                item.profitableKit[0].price -
                  item.profitableKit[0].price * (item.kitDisc / 100)
              )
            state.cart.price -=
              item.qty *
              Math.ceil(
                item.profitableKit[1].price -
                  item.profitableKit[1].price * (item.kitDisc / 100)
              )
            state.cart.priceUsd -=
              item.qty *
              Math.ceil(
                item.profitableKit[0].priceUsd -
                  item.profitableKit[0].priceUsd * (item.kitDisc / 100)
              )
            state.cart.priceUsd -=
              item.qty *
              Math.ceil(
                item.profitableKit[1].priceUsd -
                  item.profitableKit[1].priceUsd * (item.kitDisc / 100)
              )
          } else {
            state.cart.price -=
              item.qty * Math.ceil(item.profitableKit[0].price * 0.8)
            state.cart.price -=
              item.qty * Math.ceil(item.profitableKit[1].price * 0.8)
            state.cart.priceUsd -=
              item.qty * Math.ceil(item.profitableKit[0].priceUsd * 0.8)
            state.cart.priceUsd -=
              item.qty * Math.ceil(item.profitableKit[1].priceUsd * 0.8)
          }
        }
        item.qty = q
        state.cart.price += q * productPrice(item)
        state.cart.priceUsd += q * productPriceUsd(item)
        if (Array.isArray(item.profitableKit) && item.profitableKit.length) {
          console.log(item.kitDisc, 'Array.isArray3')
          if (item.kitDisc) {
            state.cart.price +=
              qty *
              Math.ceil(
                item.profitableKit[0].price -
                  item.profitableKit[0].price * (item.kitDisc / 100)
              )
            state.cart.price +=
              qty *
              Math.ceil(
                item.profitableKit[1].price -
                  item.profitableKit[1].price * (item.kitDisc / 100)
              )
            state.cart.priceUsd +=
              qty *
              Math.ceil(
                item.profitableKit[0].priceUsd -
                  item.profitableKit[0].priceUsd * (item.kitDisc / 100)
              )
            state.cart.priceUsd +=
              qty *
              Math.ceil(
                item.profitableKit[1].priceUsd -
                  item.profitableKit[1].priceUsd * (item.kitDisc / 100)
              )
          } else {
            state.cart.price +=
              qty * Math.ceil(item.profitableKit[0].price * 0.8)
            state.cart.price +=
              qty * Math.ceil(item.profitableKit[1].price * 0.8)
            state.cart.priceUsd +=
              qty * Math.ceil(item.profitableKit[0].priceUsd * 0.8)
            state.cart.priceUsd +=
              qty * Math.ceil(item.profitableKit[1].priceUsd * 0.8)
          }
          q += qty * 2
        }
        state.cart.qty += q
      }
    },
    removeWarranty(state, id) {
      state.cart.items = state.cart.items.map(item => {
        item.warranty = item.warranty.filter(w => {
          let _w = w.split(';')
          return _w[0] !== id
        })
        return item
      })
    },
    resetCart(state) {
      state.cart.items = []
      state.cart.price = 0
      state.cart.priceUsd = 0
      state.cart.qty = 0
    },
    setAddedNotice(state, data) {
      state.cart.addedNotice = data
    },
    setDeliveryPhone(state, data) {
      state.delivery.phone = data
    },
    setDeliveryName(state, data) {
      state.delivery.userName = data
    },
    setDeliveryMethod(state, data) {
      state.delivery.method = data
    },
    setDeliveryCityRefs(state, data) {
      state.delivery.cityRefs = data
    },
    setDeliveryDepartmentRefs(state, data) {
      state.delivery.departmentRefs = data
    },
    setDeliveryCity(state, data) {
      state.delivery.cityId = data
    },
    setDeliveryDepartment(state, data) {
      state.delivery.departmentId = data
    },
    setOrder(state, data) {
      state.order = data
    },
    completeOrder(state, data) {
      state.payment = Object.assign(state.payment, data)
    },
    setPayment(state, data) {
      state.payment = data
    },
    updatePayment(state, data) {
      if (typeof data !== 'object') data = {}
      state.payment = Object.assign({}, state.payment, data)
    },
    setPaymentRedirectUrl(state, url) {
      state.payment.url = url
    },
    setPaymentSubmitData(state, data) {
      state.submit.data = data
    },
    setPaymentTransferData(state, data) {
      state.transfer.data = data
    },
    setPaymentResult(state, data) {
      state.payment.result = data
    },
    setTradeIn(state, data) {
      state.tradeIn = data
    },
    setRepair(state, data) {
      state.repair = data
    },
    setBlog(state, data) {
      state.blog.posts = data
    },
    setPostPage(state, data) {
      state.blog.page = data
    },
    setPostPerPage(state, data) {
      state.blog.perPage = data
    },
    setPostTotalPages(state, data) {
      state.blog.posts.total = data
    },
    setFranchise(state, data) {
      state.franchise = data
    },
    appendReview(state, data) {
      state.product.feedbacks.push(data)
    },
    setLanguage(state, data) {
      state.lang = data
    },
  }
}

function productPrice(product) {
  return product.newPrice ? product.newPrice : product.price
}

function productPriceUsd(product) {
  return product.newPriceUsd ? product.newPriceUsd : product.priceUsd
}

function productLink(product, state) {
  const { lang } = state
  let { categories: _c } = state
  const { childCategory, parentCategory } = product
  const cc = Array.isArray(childCategory)
    ? childCategory.toString()
    : childCategory || ''
  const refPath = `${parentCategory}/${cc.replace(',', '/')}`
  let categoryPath = ''
  const chain = refPath.split('/')
  chain.forEach(p => {
    if (!_c) return
    let c = _c.find(c => c.id === p)
    if (c) {
      _c = c.children || null
      if (categoryPath !== '') categoryPath += '/'
      categoryPath += c.slug
    }
  })
  const link = '/product/' + categoryPath + '/' + product.slug

  return lang ? '/' + lang + link : link
}
